import { render, staticRenderFns } from "./IconAnnotationOutline.vue?vue&type=template&id=449145d7"
import script from "./IconAnnotationOutline.vue?vue&type=script&lang=js"
export * from "./IconAnnotationOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports